export const tipLeftBasePosition = -89
export const screenBorderWidth = 20
export const tipWidth = 200
